import {Injectable} from '@angular/core';
import {HttpService} from '../http.service';
import {DepositMode} from '../../../shared-gen/Payment/Status/DepositMode';

/**
 * Web API for payment related functions.
 */
@Injectable({
	providedIn: 'root'
})
export class PaymentApi extends HttpService {

	/**
	 * Sets the current [DepositMode] for inserted coins (either Credit or Change).
	 */
	async setCoinsDepositMode(mode: DepositMode): Promise<void> {
		await this.post<void>('payment/coinsdepositmode/' + mode);
	}

}
